import { render, staticRenderFns } from "./modalReferensiPemilikBarang.vue?vue&type=template&id=dcbab40a&"
import script from "./modalReferensiPemilikBarang.vue?vue&type=script&lang=js&"
export * from "./modalReferensiPemilikBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports